import React, { lazy } from 'react';
import { useInView } from '../hooks/useInView';
export function PainSection() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section ref={ref} className="w-full bg-cream py-10 px-6 md:py-14" data-id="element-151">
      <div className={`max-w-2xl mx-auto space-y-12 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-152">
        {/* Subsection 1 */}
        <article className="space-y-4" data-id="element-153">
          <h2 className="font-serif text-3xl text-navy font-bold" data-id="element-154">
            Esto no se siente como "un problema"
          </h2>
          <div className="text-text-dark font-sans text-lg leading-relaxed" data-id="element-155">
            <p className="mb-3" data-id="element-156">Se siente como tu vida normal.</p>
            <ul className="list-none space-y-1 mb-4 pl-4 border-l-2 border-gold/30" data-id="element-157">
              <li data-id="element-158">- La cabeza haciendo lista.</li>
              <li data-id="element-159">- El cuerpo cansado.</li>
              <li data-id="element-160">- El corazón con culpa.</li>
            </ul>
            <p className="mb-3" data-id="element-161">
              Y una idea que se repite con diferentes disfraces:
            </p>

            <div className="space-y-2 my-5 pl-5" data-id="element-162">
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-163">
                "Podrías hacerlo mejor."
              </p>
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-164">
                "Deberías ser más paciente."
              </p>
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-165">
                "Cómo no vas a poder."
              </p>
              <p className="font-serif italic text-xl text-navy border-l-4 border-gold pl-4 py-0.5" data-id="element-166">
                "Mira a las otras…"
              </p>
            </div>

            <p className="font-medium text-navy" data-id="element-167">
              La Mamá Juez no descansa.
              <br data-id="element-168" />Y cuando tú por fin te sientas… recién empieza a hablar más
              fuerte.
            </p>
          </div>
        </article>

        {/* Emotional image */}
        <div className="w-full max-w-md mx-auto rounded-xl overflow-hidden shadow-md" data-id="element-169">
          <img src="https://cdn.magicpatterns.com/uploads/ow4tQ5Yush19rtAkWXrvDR/ChatGPT_Image_18_feb_2026,_10_48_36.png" alt="Mamá reflexionando" loading="lazy" className="w-full h-auto" data-id="element-170" />
        </div>

        {/* Subsection 2 */}
        <article className="space-y-4" data-id="element-171">
          <h2 className="font-serif text-3xl text-navy font-bold" data-id="element-172">
            Un patrón exigente que se repite
          </h2>
          <div className="text-text-dark font-sans text-lg leading-relaxed" data-id="element-173">
            <div className="bg-white p-5 rounded-lg shadow-sm border border-gold/10 space-y-2 mb-4" data-id="element-174">
              <p data-id="element-175">
                <span className="font-bold text-navy" data-id="element-176">Si trabajas →</span> "no
                estás."
              </p>
              <p data-id="element-177">
                <span className="font-bold text-navy" data-id="element-178">
                  Si te quedas en casa →
                </span>{' '}
                "no aportas."
              </p>
              <p data-id="element-179">
                <span className="font-bold text-navy" data-id="element-180">Si haces ambas →</span>{' '}
                "igual no alcanza."
              </p>
            </div>
            <p data-id="element-181">
              Ese estándar no está diseñado para que vivas. Está diseñado para
              que te cobres.
            </p>
            <p className="font-medium text-navy text-xl mt-2" data-id="element-182">
              Y cuando una madre se cobra todo… se queda sin aire para
              disfrutar.
            </p>
          </div>
        </article>

        {/* Subsection 3 */}
        <article className="space-y-4" data-id="element-183">
          <h2 className="font-serif text-3xl text-navy font-bold" data-id="element-184">
            No es debilidad.
          </h2>
          <div className="text-text-dark font-sans text-lg leading-relaxed" data-id="element-185">
            <p data-id="element-186">Es un patrón aprendido.</p>
            <p className="mt-2" data-id="element-187">
              Tu mente usa la crítica como una forma de control.
            </p>
            <p className="mt-2" data-id="element-188">
              Porque si te exiges, crees que: no te equivocas, no fallas, no te
              juzgan, tus hijos "están bien".
            </p>
            <p className="mt-3" data-id="element-189">Pero hay un costo.</p>
            <p data-id="element-190">
              La exigencia constante no te vuelve mejor. Te vuelve dura contigo.
            </p>
            <p className="font-serif text-2xl text-gold-dark mt-3 italic" data-id="element-191">
              Y una mamá dura consigo… se queda sin ternura para su propia vida.
            </p>
          </div>
        </article>
      </div>
    </section>;
}